import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import API from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }
    API.post("/auth/google/session", { session_id: sessionId })
      .then((res) => {
        window.history.replaceState({}, document.title, "/admin");
        navigate("/admin", { state: { user: res.data }, replace: true });
      })
      .catch(() => {
        window.history.replaceState({}, document.title, "/admin");
        navigate("/admin", { replace: true });
      });
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center" data-testid="auth-callback">
      <p className="font-display italic text-2xl text-mist">Unlocking the desk&hellip;</p>
    </div>
  );
}
